// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"backdrop_backdrop__BoU-m","elevated":"backdrop_elevated__2k1e5"};